
import ContentModal from './content-modal.vue';

export default {
  name: 'TermsModal',
  components: {
    ContentModal,
  },
};
